/* 찾기 맞춤: 대소문자 무시 부분 일치 + 한글 초성 ("ㄱㅈ" → "견적") */

const CHOSEONG = "ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ";

export const toChoseong = (s: string) =>
  Array.from(s, (ch) => {
    const code = ch.charCodeAt(0) - 0xac00;
    return code >= 0 && code <= 11171 ? CHOSEONG[Math.floor(code / 588)] : ch;
  }).join("");

export const isChoseongOnly = (q: string) => /^[ㄱ-ㅎ\s]+$/.test(q);

/** 맞는 정도: 0 = 아님, 3 = 처음부터, 2 = 낱말 처음, 1 = 가운데. 앞의 #·@는 무시한다 */
export function matchScore(label: string, query: string): number {
  const q = query.trim().toLowerCase().replace(/^[#@]/, "");
  if (!q) return 1;
  const text = label.toLowerCase().replace(/^[#@]/, "");
  const choseong = isChoseongOnly(q);
  const hay = choseong ? toChoseong(text) : text;
  const needle = q.replace(/\s+/g, choseong ? "" : " ");
  const at = hay.indexOf(needle);
  if (at < 0) return 0;
  if (at === 0) return 3;
  return /[\s/_-]/.test(hay[at - 1]!) ? 2 : 1;
}
